import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'sigv-fixed-top-panel',
  templateUrl: './fixed-top-panel.component.html',
  styleUrls: ['./fixed-top-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('animation', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(-100%)',
        })
      ),
      state(
        'open',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        })
      ),
      transition('void => open', animate('{{showTransitionParams}}')),
      transition('open => void', animate('{{hideTransitionParams}}')),
    ]),
  ],
})
export class FixedTopPanelComponent implements OnInit, OnDestroy {
  scrollListener: any;
  visible = false;
  constructor(public el: ElementRef, private cd: ChangeDetectorRef) {}

  @Input() styleClass = '';
  @Input() showTransitionOptions = '.15s';
  @Input() hideTransitionOptions = '.15s';
  @Input() threshold = 400;

  ngOnInit(): void {
    this.bindDocumentScrollListener();
  }

  ngOnDestroy(): void {
    this.unbindDocumentScrollListener();
  }

  checkVisibility(scrollY: number): void {
    if (scrollY > this.threshold) {
      this.visible = true;
    } else {
      this.visible = false;
    }

    this.cd.markForCheck();
  }

  bindDocumentScrollListener(): void {
    this.scrollListener = () => {
      this.checkVisibility(this.getWindowScrollTop());
    };

    window.addEventListener('scroll', this.scrollListener);
  }

  unbindDocumentScrollListener(): void {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
      this.scrollListener = null;
    }
  }

  getWindowScrollTop(): number {
    const doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  }
}
